import React from 'react';
import { CurrUserCtxProvider } from './CurrUserContext';
import { DeviceCtxProvider } from './DeviceContext';
import { NotifCtxProvider } from './NotifContext';
import { OrganizationCtxProvider } from './OrganizationContext';
import { UserCtxProvider } from './UserContext';
import { ImpersonationCtxProvider } from './ImpersonationContext';

function AuthedAppProviders({ children }) {
  return (
    <CurrUserCtxProvider>
      <OrganizationCtxProvider>
        <UserCtxProvider>
          <ImpersonationCtxProvider>
            <DeviceCtxProvider>
              <NotifCtxProvider>{children}</NotifCtxProvider>
            </DeviceCtxProvider>
          </ImpersonationCtxProvider>
        </UserCtxProvider>
      </OrganizationCtxProvider>
    </CurrUserCtxProvider>
  );
}

export default AuthedAppProviders;
